export interface DividerProps {
  customClass?:any
}

function Divider({customClass = "border-gray-300 my-8"}:DividerProps) {
  return <div className={`border ${customClass}`}/>
}

export default Divider